import { District, CreateDistrictRequest, UpdateDistrictRequest } from "@/models/district";
import { assertTokenValidForMutation, handleResponse } from "@/services/service-helpers";
import log from '@/lib/logger';

const NBH_DISTRICTS_BASE_URL = `${import.meta.env.VITE_NBH_URL_ROOT}/api/districts`;
const NBH_DISTRICTS_ADMIN_BASE_URL = `${import.meta.env.VITE_NBH_URL_ROOT}/api/admin/districts`;

export async function fetchAllDistricts(token: string | null): Promise<District[] | void> {
    if (!token) {
        log.error("No token provided. Cannot fetch districts.");
        return Promise.reject("No token provided.");
    }

    const response = await fetch(`${NBH_DISTRICTS_BASE_URL}`, {
        method: "GET",
        headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json"
        }
    });

    return handleResponse<District[]>(response);
}

export async function createDistrict(
    token: string | null,
    request: CreateDistrictRequest
): Promise<District | void> {
    if (!token) {
        log.error("No token provided. Cannot create district.");
        return Promise.reject("No token provided.");
    }
    assertTokenValidForMutation()

    const response = await fetch(`${NBH_DISTRICTS_ADMIN_BASE_URL}`, {
        method: "POST",
        headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json"
        },
        body: JSON.stringify(request)
    });

    return handleResponse<District>(response);
}

export async function updateDistrict(
    token: string | null,
    id: string,
    request: UpdateDistrictRequest
): Promise<District | void> {
    if (!token) {
        log.error("No token provided. Cannot update district.");
        return Promise.reject("No token provided.");
    }
    assertTokenValidForMutation()

    const response = await fetch(`${NBH_DISTRICTS_ADMIN_BASE_URL}/${id}`, {
        method: "PATCH",
        headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json"
        },
        body: JSON.stringify(request)
    });

    return handleResponse<District>(response);
}

export async function deleteDistrict(token: string | null, id: string): Promise<void> {
    if (!token) {
        log.error("No token provided. Cannot delete district.");
        return Promise.reject("No token provided.");
    }
    assertTokenValidForMutation()

    const response = await fetch(`${NBH_DISTRICTS_ADMIN_BASE_URL}/${id}`, {
        method: "DELETE",
        headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json"
        }
    });

    return handleResponse<void>(response);
}
